import React from "react";
import { createRoot } from "react-dom/client";

import "./index.css";

import i18n from "./i18n/index.js";
import {
  detectAppLanguage,
} from "./i18n/detectLanguage.js";

import App from "./App.jsx";
import WebAuthGate from "./WebAuthGate.jsx";

import AppEntry from "./AppEntry.jsx";
import LandingPage from "./LandingPage.jsx";

const syncAppLanguage = () => {
  const nextLanguage =
    detectAppLanguage();

  if (
    i18n.resolvedLanguage !==
    nextLanguage
  ) {
    void i18n.changeLanguage(
      nextLanguage
    );
  }
};

syncAppLanguage();

if (typeof window !== "undefined") {
  window.setTimeout(
    syncAppLanguage,
    250
  );

  window.setTimeout(
    syncAppLanguage,
    1000
  );
}

const container =
  document.getElementById("root");

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AppEntry
      landing={<LandingPage />}
    >
      <WebAuthGate>
        <App />
      </WebAuthGate>
    </AppEntry>
  </React.StrictMode>
);